import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { UserRoles } from "@/constant";

export function isPlatformAdminUser(roles?: string[] | null): boolean {
  return Array.isArray(roles) && roles.includes(UserRoles.ADMIN);
}

// Returns array of roles, fallback to [UserRoles.ADMIN] if not present
export function useCurrentUserRoles(): string[] {
  const roles = useSelector((state: RootState) => state?.auth?.userData?.roles);
  if (Array.isArray(roles) && roles.length > 0) {
    return roles;
  }
  return [UserRoles.ADMIN];
}

export function useIsPlatformAdmin(): boolean {
  const roles = useSelector((state: RootState) => state?.auth?.userData?.roles);
  return isPlatformAdminUser(roles);
}
